module.exports = __webpack_public_path__ + "img/4b1f50c.png";